var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 3.33333H9.33333V5.33333H7.33333V6.66667H9.33333V8.66667H10.6667V6.66667H12.6667V5.33333H10.6667V3.33333ZM1.33333 6C1.33333 4.14 2.42667 2.53333 4.00667 1.78667V0.346667C1.68 1.17333 0 3.39333 0 6C0 8.60667 1.68 10.8267 4.00667 11.6533V10.2133C3.2075 9.83669 2.53187 9.24062 2.05854 8.49463C1.58522 7.74865 1.33371 6.88348 1.33333 6ZM10 0C6.69333 0 4 2.69333 4 6C4 9.30667 6.69333 12 10 12C13.3067 12 16 9.30667 16 6C16 2.69333 13.3067 0 10 0ZM10 10.6667C7.42667 10.6667 5.33333 8.57333 5.33333 6C5.33333 3.42667 7.42667 1.33333 10 1.33333C12.5733 1.33333 14.6667 3.42667 14.6667 6C14.6667 8.57333 12.5733 10.6667 10 10.6667Z",
    fill: "#111B23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.fa74c3488abb50b9b2248e0d4ca75380.svg";
export { ForwardRef as ReactComponent };